module.exports = __webpack_public_path__ + "static/media/ex-alunos.d9f37137.jpg";